<div class="container-fluid mt-4 vh-100 no-user-select">
    <div class="journey-card rounded-4 p-3 mb-3 position-relative" *ngFor="let ride of rideShareEntires">
        <div class="d-flex flex-column justify-content-between align-items-start mb-3">
            <div class="d-flex justify-content-between align-items-start w-100">
                <h6 class="fw-normal mb-1">{{ride.offeredBy}}</h6>
                <div *ngIf="ride.isEditable">
                    <i class="bi bi-pencil-square text-muted cursor-pointer me-3" (click)="editRide(ride)"></i>
                    <i class="bi bi-trash text-muted cursor-pointer" (click)="onDelete(ride)"></i>
                </div>
            </div>
            <div class="d-flex align-items-center gap-2" *ngIf="ride.isEditable">
                <span class="badge rounded-pill editable-tag" style="font-size: 0.75rem;">Posted by you</span>
            </div>
        </div>

        <p class="mb-1">Starting point: {{ride.startingPoint}}</p>
        <p class="mb-1">Destination: {{ride.destination}}</p>
        <p class="mb-3">Date of travel: {{ride.dateOfTravel | date:'dd/MM/yyyy'}}</p>

        <div class="px-3 py-1 mx-auto text-center gradient-border-primary seats-available">
            <span class="text-muted small">Space available for: <span
                    class="text-danger fw-semibold">{{ride.availableSeats.adults}} adults</span> |
                <span class="text-danger fw-semibold">{{ride.availableSeats.children}} children</span></span>
        </div>
    </div>
    <div *ngIf="rideShareEntires.length<1" class="align-content-center text-center w-100" style="height:80%">
        No rides available yet...
    </div>
</div>
<div
    class="sticky-bottom-buttons text-center col-12 d-flex flex-nowrap gap-2 justify-content-center align-items-center px-md-0 mt-1 pb-3">
    <button
        class="col-md-3 col-12 t-btn-primary text-decoration-none fw-bold cursor-pointer align-content-center t-hover-scale w-md-auto"
        (click)="openManageModal()">
        {{isLoggedIn ? '':'Login to '}}Update Your Travel Plans
    </button>
</div>

<div class="modal fade show" *ngIf="showTravelModal" tabindex="-1" style="display: block;">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content rounded-4 p-1">

            <div class="modal-header border-0">
                <h5 class="modal-title fw-semibold">Travel plans</h5>
                <button type="button" class="btn-close" (click)="closeTravelModal()"></button>
            </div>
            <hr>

            <form [formGroup]="travelForm" (ngSubmit)="onSubmit()" class="modal-body pt-0">
                <div class="mb-3">
                    <input type="text" formControlName="name" class="form-control rounded-pill" placeholder="Your name">
                </div>
                <div class="mb-3">
                    <input type="text" formControlName="startingPoint" class="form-control rounded-pill"
                        placeholder="Starting point">
                </div>
                <div class="mb-3">
                    <input type="text" formControlName="destination" class="form-control rounded-pill"
                        placeholder="Destination">
                </div>
                <div class="mb-3 position-relative">
                    <label>Date of Travel</label>
                    <input type="date" formControlName="dateOfTravel" class="form-control rounded-pill"
                        placeholder="Date of Travel" [min]="today">
                </div>
                <div class="mb-3 fw-normal">Can accommodate</div>

                <div class="d-flex justify-content-between align-items-center mb-3">
                    <label class="me-2 mb-0">Adults</label>
                    <div class="d-flex align-items-center">
                        <button type="button"
                            class="btn btn-outline-secondary rounded-circle d-flex align-items-center justify-content-center"
                            style="width: 36px; height: 36px;" (click)="adjustCount('adults', -1)">
                            −
                        </button>

                        <span class="mx-3">{{ travelForm.get('adults')?.value }}</span>

                        <button type="button"
                            class="btn btn-outline-secondary rounded-circle d-flex align-items-center justify-content-center"
                            style="width: 36px; height: 36px;" (click)="adjustCount('adults', 1)">
                            +
                        </button>

                    </div>
                </div>

                <div class="d-flex justify-content-between align-items-center mb-4">
                    <label class="me-2 mb-0">Children</label>
                    <div class="d-flex align-items-center">
                        <button type="button"
                            class="btn btn-outline-secondary rounded-circle d-flex align-items-center justify-content-center"
                            style="width: 36px; height: 36px;" (click)="adjustCount('children', -1)">−</button>
                        <span class="mx-3">{{ travelForm.get('children')?.value }}</span>
                        <button type="button"
                            class="btn btn-outline-secondary rounded-circle d-flex align-items-center justify-content-center"
                            style="width: 36px; height: 36px;" (click)="adjustCount('children', 1)">+</button>
                    </div>
                </div>
                <hr>
                <button type="submit" class="w-100 t-btn-primary" [disabled]="travelForm.invalid">
                    Update details
                </button>

            </form>
        </div>
    </div>
</div>
<div class="modal-backdrop fade show" *ngIf="showTravelModal"></div>